import type { SVGProps } from 'react';

type SVGRProps = {
  title?: string;
  titleId?: string;
};

export const Refresh = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}

    <path
      d="M14.4333 0.266667L12.8333 1.9C11.5333 0.733333 9.83333 0 8 0C4.83333 0 2.06667 2.03333 1.1 5.03333C0.933333 5.6 1.23333 6.2 1.8 6.36667C2.36667 6.53333 2.96667 6.23333 3.13333 5.66667C3.8 3.56667 5.76667 2.13333 8 2.13333C9.23333 2.13333 10.4333 2.63333 11.3333 3.4L9.83333 4.86667C9.3 5.43333 9.66667 6.4 10.4667 6.4H15.3667C15.7 6.4 16 6.13333 16 5.76667V0.933333C16 0.1 15 -0.3 14.4333 0.266667ZM14.1667 8.6C13.6 8.43333 13 8.73333 12.8333 9.3C12.1667 11.4 10.2 12.8 8 12.8C6.73333 12.8 5.56667 12.3333 4.63333 11.5667L6.13333 10.0667C6.66667 9.53333 6.3 8.56667 5.5 8.53333H0.6C0.266667 8.56667 0 8.83333 0 9.2V14.0333C0 14.8667 0.966667 15.2667 1.53333 14.7L3.13333 13.0667C4.43333 14.2333 6.13333 14.9333 7.96667 14.9333C11.1 14.9333 13.8667 12.9333 14.8333 9.93333C15.0333 9.36667 14.7333 8.76667 14.1667 8.6Z"
      fill="currentColor"
    />
  </svg>
);
